// src/store/modules/rolePreview.js

import { RESERVED_ROLE_IDS } from '@/constants/roles'

export default {
  namespaced: true,
  state: () => ({
    activeRoles: null, // null = off, string[] = overriding
  }),
  mutations: {
    SET_ACTIVE_ROLES(state, roles) {
      state.activeRoles = roles
    },
    CLEAR_PREVIEW(state) {
      state.activeRoles = null
    },
  },
  actions: {
    enablePreview({ commit }, roles) {
      // Reserved roles (security, admin) gate backend mutations by literal
      // role_id. Allowing a preview to simulate them would expose mutation UI
      // that the backend would then 403 on action. Strip them here so the
      // preview stays read-only-equivalent to non-privileged identities.
      const safeRoles = (roles || []).filter(r => !RESERVED_ROLE_IDS.includes(r))
      if (safeRoles.length === 0) {
        commit('CLEAR_PREVIEW')
        return
      }
      commit('SET_ACTIVE_ROLES', safeRoles)
    },
    disablePreview({ commit }) {
      commit('CLEAR_PREVIEW')
    },
  },
  getters: {
    isPreviewActive: (state) => state.activeRoles !== null,
    activeRoles: (state) => state.activeRoles,
  },
}
